import React from "react";
import SubscriptionDashboard from "../../components/subscription/SubscriptionDashboard";

const SubscriptionPage = () => <SubscriptionDashboard />;

export default SubscriptionPage;
